import styled from '@emotion/styled'
import Breadcrumb from '../../../components/common/Breadcrumb'
import Card from '../../../components/common/Card'
import iconUser from '../../../assets/images/icons-user-green-32-px.svg'
import iconUserGroup from '../../../assets/images/icons-user-group-green-32-px.svg'
import iconChange from '../../../assets/images/icons-change-green-24-px.svg'
import Text from '../../../components/common/Text'
import Welfare from './Welfare'
import FooterContent from '../../../components/FooterContent'
import { useScreen } from '../../../utils/responsive-helper'
import Button from '../../../components/common/Button'
import { useCallback, useEffect, useMemo, useState } from 'react'
import * as paths from '../../../constant/path'
import { useHistory } from 'react-router'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import {
  useGetEnrollmentSelectPeriod,
} from '../../../services/enrollment/enrollment-query'
import { useGetUser } from '../../../services/user/user-query'
import { convertDateFormatTH, DateFormat } from '../../../utils/dateFormat'
import { useGetEnrollmentYear } from '..'
import { useRouter, useCanEditable } from '../../../utils/helper'
import color from '../../../constant/colors'
import { PeriodTabsLayout, PeriodTabButton } from '../Benefits/EditBenefits/shared'
import HealthCheckupDetailRoute from './HealthCheckupDetailRoute'
import { useDispatch } from 'react-redux'
import { setEnrollment } from '../../../redux-store/enrollment-reducer'

const Layout = styled.div`
  > * {
    margin-top: 24px;
  }
  text-align: center;
`

const EnrollmentDetailLayout = () => {
  const dispatch = useDispatch()
  const { query } = useRouter()
  const history = useHistory()
  // const { data: user } = useGetUser()
  // const { lastEnrollDate: lastEnrollDateUser = 0 } = user || {}
  const { data: enrollmentPeriod, isLoading: isLoadingPresentPeriod } = useGetEnrollmentSelectPeriod()
  const {
    startEnrollmentDate: presentStartDate = 0,
    endEnrollmentDate: presentEndDate = 0,
    benefitYearId: benefitYearPresentId,
  } = enrollmentPeriod || {}

  const [benefitYearId, setBenefitYearId] = useState(0)
  const [isLoading, setIsLoading] = useState(false)

  const startDate = useMemo(() => {
    let startDate = 0
    switch (benefitYearId) {
      case benefitYearPresentId:
        startDate = presentStartDate
        break
      // case benefitYearNextId:
      //   startDate = nextStartDate
      //   break
      default:
        startDate = presentStartDate
        break
    }

    return startDate
  }, [benefitYearId, benefitYearPresentId, presentStartDate])

  const endDate = useMemo(() => {
    let endDate = 0
    switch (benefitYearId) {
      case benefitYearPresentId:
        endDate = presentEndDate
        break
      // case benefitYearNextId:
      //   endDate = nextEndDate
      //   break
      default:
        endDate = presentEndDate
        break
    }

    return endDate
  }, [benefitYearId, benefitYearPresentId, presentEndDate])

  const { enrollmentYear } = useGetEnrollmentYear(startDate)

  const canEditable = useCanEditable(startDate, endDate)

  useEffect(() => {
    if (benefitYearPresentId) {
      setBenefitYearId(benefitYearPresentId)
    }
  }, [benefitYearPresentId])

  useEffect(() => {
    // dispatch(
    //   setEnrollment({
    //     benefitYearId: benefitYearId,
    //     enrollmentYear: enrollmentYear.toString(),
    //     startDate: startDate,
    //     endDate: endDate,
    //     benefitYear: benefitYear,
    //   }),
    // )
    setIsLoading(true)
  }, [benefitYearId, startDate, endDate, enrollmentYear, dispatch])

  const onChangeBenefitYear = useCallback(
    (e) => {
      if (canEditable) {
        history.push(
          paths.healthCheckup(),
        )
      }
      setBenefitYearId(e.target.value)
    },
    [benefitYearId, endDate, history],
  )

  return (
    <>
      {!isLoadingPresentPeriod && isLoading && (
        <Layout>
          {/* <PeriodTabsLayout
            defaultValue={benefitYearId}
            buttonStyle="solid"
            onChange={onChangeBenefitYear}
            isNextPeriod={false}
          > */}
          {/* <PeriodTabButton value={benefitYearPresentId}>
              แผนประกันปี {benefitYearPresent + 543}
            </PeriodTabButton> */}
          {/* {!isErrorNextPeriod && (
              <PeriodTabButton value={benefitYearNextId}>
                แผนประกันปี {benefitYearNext + 543}
              </PeriodTabButton>
            )} */}
          {/* </PeriodTabsLayout> */}
          <HealthCheckupDetailRoute />
        </Layout>
      )}
    </>
  )
}

export default EnrollmentDetailLayout
